import { useSearchParams } from 'next/navigation'

import { useQuery } from '@tanstack/react-query'

import { GetPageViewModel } from '@/types/cml-api'
import { HomePageReactQueryKeys } from '@/types/home-page'

import { fetchPageData } from './fetch-page-data'

export function useHomePageData(slug = '/') {
    const searchParams = useSearchParams()
    const isPreview = searchParams.get('preview') === 'true'

    return useQuery<GetPageViewModel>({
        queryKey: [HomePageReactQueryKeys.HomeProperties, { slug, isPreview }],
        queryFn: () => fetchPageData({ slug, isPreview }),
        refetchOnMount: false,
    })
}
